<template>
  <div>
    <header-slot>
      <template v-slot:content-right>
        <b-button
          v-if="routeName == 'general-email-recipients-group'"
          v-b-tooltip.hover
          :title="$t('Add Recipient Group')"
          variant="outline-success"
          size="sm"
          @click="openAddRecipientGroupModal"
        >
          <feather-icon icon="PlusIcon"></feather-icon>
        </b-button>
      </template>
    </header-slot>
    <b-nav card-header pills class="m-0">
      <b-nav-item
        v-for="(item, index) in tabs"
        :key="index"
        :to="{ name: item.name }"
        exact
        exact-active-class="active"
        :link-classes="['px-3', bgTabsNavs]"
        >{{ $t(item.title) }}
      </b-nav-item>
    </b-nav>
    <b-card
      no-body
      class="border-top-primary border-3 border-table-radius px-0"
    >
      <router-view :key="key" />
    </b-card>

    <AddRecipientGroup
      v-if="showModalAddRecipientGroup"
      @close="showModalAddRecipientGroup = false"
      @save="onSaveAddRecipientGroup"
    />
  </div>
</template>

<script>
import AddRecipientGroup from "@/views/settings/views/general/components/email/components/AddRecipientGroup.vue";

export default {
  components: {
    AddRecipientGroup,
  },
  computed: {
    tabs() {
      return this.$route.matched[1].meta.tabs;
    },
    routeName() {
      return this.$route.name;
    },
  },
  data() {
    return {
      key: "default",
      showModalAddRecipientGroup: false,
    };
  },
  methods: {
    openAddRecipientGroupModal() {
      this.showModalAddRecipientGroup = true;
    },
    generateKey() {
      this.key =
        Math.random().toString(36).substring(2, 15) +
        Math.random().toString(36).substring(2, 15);
    },
    onSaveAddRecipientGroup() {
      this.showModalAddRecipientGroup = false;
      this.generateKey();
    },
  },
};
</script>

<style>
</style>